import { FC } from "react";
import classNames from "classnames";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";
import ModuleTile from "../../ModuleTile/ModuleTile";
import { SectionLayoutProps } from "../Section.types";

const SectionMob: FC<SectionLayoutProps> = ({ title, items, subtitle, emblaRef, emblaApi }) => {
  const handleMovement = (direction: "Next" | "Prev") => () => {
    return direction === "Next" ? emblaApi?.scrollNext() : emblaApi?.scrollPrev();
  };
  return (
    <div className="flex flex-col gap-4 py-3">
      <div className="flex items-start justify-between gap-2">
        <div className="flex h-full flex-1 flex-col items-start justify-start">
          <div className="text-2xl font-medium">{title}</div>
          <div className="text-font-subtle text-xs">{subtitle}</div>
        </div>
        {items.length > 1 && (
          <div className="flex gap-1">
            <button
              onClick={handleMovement("Prev")}
              className="text-font-active bg-background-primary-lighter disabled:bg-background-disabled disabled:text-font-disabled rounded-sm p-2 transition-colors"
            >
              <MdChevronLeft />
            </button>
            <button
              onClick={handleMovement("Next")}
              className="text-font-active bg-background-primary-lighter disabled:bg-background-disabled disabled:text-font-disabled rounded-sm p-2 transition-colors"
            >
              <MdChevronRight />
            </button>
          </div>
        )}
      </div>
      <div ref={emblaRef} className="flex-1 overflow-hidden">
        <div
          className={classNames(
            "grid grid-flow-col grid-rows-1 items-center gap-2",
            items.length > 1 ? "auto-cols-[calc(100%-20px)]" : "auto-cols-[100%]",
          )}
        >
          {items.map((item) => (
            <div key={item.key} className="h-60">
              <ModuleTile item={item} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SectionMob;
